import { LinkBuilder } from './link-builder';
import { Map } from './map-services/map';

export class ReolyzerFactory {
  static createLinkBuilder(refCat: string): Promise<LinkBuilder> {
    return LinkBuilder.fetchData(refCat);
  }

  static createMap(mapPoints: any[]): Map {
    const points = Map.convertToMapPoints(mapPoints);
    return new Map(points);
  }
}
